import React from 'react';
import { styled } from '@linaria/react';
import { Card } from '@daedalus/atlas/Card';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Divider } from '@daedalus/atlas/Divider';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
import { ROOM_CARD_GALLERY_HEIGHT_DESKTOP, ROOM_CARD_GALLERY_HEIGHT_MOBILE } from '../constants';
import { RoomsFiltersTitle } from '../RoomsFilters';
const _exp = /*#__PURE__*/() => SkeletonLoader;
const FilterSkeleton = /*#__PURE__*/styled(_exp())({
  name: "FilterSkeleton",
  class: "f1v2c8xl",
  propsAsIs: true
});
const RoomInfoWrapper = /*#__PURE__*/styled('div')({
  name: "RoomInfoWrapper",
  class: "rvc58p0",
  propsAsIs: false
});
const RoomInfo = /*#__PURE__*/styled('div')({
  name: "RoomInfo",
  class: "rmbjw5q",
  propsAsIs: false
});
const _exp6 = /*#__PURE__*/() => Flex.Column;
const RoomOffersListWrapperDesktop = /*#__PURE__*/styled(_exp6())({
  name: "RoomOffersListWrapperDesktop",
  class: "r1if7h2s",
  propsAsIs: true
});
export const FiltersSkeleton = () => {
  const {
    isMobile
  } = useDeviceLayout();
  return <Flex.Row gap={isMobile ? 's300' : 's500'} alignItems="center">
      <RoomsFiltersTitle />
      <Flex.Row gap="s300" alignItems="center">
        <FilterSkeleton height={34} width={136} marginTop={0} />
        <FilterSkeleton height={34} width={136} marginTop={0} />
        <FilterSkeleton height={34} width={136} marginTop={0} />
      </Flex.Row>
    </Flex.Row>;
};
const RoomOffersListSkeleton = () => <ContentWrapper padding="s500">
    <Flex.Row gap="s300" justifyContent="space-between">
      <Flex.Column gap="s250">
        <SkeletonLoader width={134} height={22} />
        <SkeletonLoader width={118} height={22} />
        <SkeletonLoader width={134} height={22} />
      </Flex.Column>
      <Flex.Column alignItems="flex-end">
        <SkeletonLoader width={144} height={22} />
        <SkeletonLoader width={128} height={22} marginTop={6} />
        <SkeletonLoader width={144} height={42} marginTop={12} />
      </Flex.Column>
    </Flex.Row>
  </ContentWrapper>;
const RoomOffersListDesktopSkeleton = () => <Flex.Row gap="s600" justifyContent="space-between">
    <Flex.Column>
      <SkeletonLoader width={138} height={22} />
      <SkeletonLoader width={138} height={22} />
    </Flex.Column>
    <Flex.Row gap="s600">
      <Flex.Column gap="s300">
        <SkeletonLoader width={138} height={22} />
        <SkeletonLoader width={138} height={22} />
      </Flex.Column>
      <SkeletonLoader width={140} height={50} />
    </Flex.Row>
  </Flex.Row>;
const RoomSkeletonDesktop = () => <Card borderColorPath="border.neutral.c100" borderRadius="lg">
    <ContentWrapper padding="s600">
      <Flex.Row gap="s600">
        <Flex.Column gap="s500">
          <SkeletonLoader height={ROOM_CARD_GALLERY_HEIGHT_DESKTOP} width={230} />
          <Flex.Column gap="s250">
            <SkeletonLoader height={28} width={176} />
            <SkeletonLoader height={22} width={138} />
            <SkeletonLoader height={22} width={138} />
          </Flex.Column>
        </Flex.Column>
        <RoomOffersListWrapperDesktop gap="s500">
          <SkeletonLoader width={224} height={22} />
          <Card borderColorPath="border.neutral.c100" borderRadius="lg">
            <ContentWrapper padding="s500">
              <Flex.Column gap="s500">
                <RoomOffersListDesktopSkeleton />
                <Divider />
                <RoomOffersListDesktopSkeleton />
                <Divider />
                <RoomOffersListDesktopSkeleton />
              </Flex.Column>
            </ContentWrapper>
          </Card>
        </RoomOffersListWrapperDesktop>
      </Flex.Row>
    </ContentWrapper>
  </Card>;
export const RoomsListSkeleton = () => {
  const {
    isMobile,
    isDesktopXs
  } = useDeviceLayout();
  const isMobileOrTablet = isMobile || isDesktopXs;
  if (isMobileOrTablet) return <Card borderColorPath="border.neutral.c100" borderRadius="lg">
        <SkeletonLoader height={ROOM_CARD_GALLERY_HEIGHT_MOBILE} />
        <RoomInfoWrapper>
          <RoomInfo>
            <SkeletonLoader width={176} height={28} />
            <SkeletonLoader width={57} height={22} />
          </RoomInfo>
          <SkeletonLoader width={115} height={22} />
          <Flex.Row justifyContent="flex-end">
            <SkeletonLoader width={144} height={22} />
          </Flex.Row>
        </RoomInfoWrapper>
        <Divider />
        <RoomOffersListSkeleton />
        <Divider sideMargin="s500" />
        <RoomOffersListSkeleton />
        <Divider sideMargin="s500" />
        <RoomOffersListSkeleton />
      </Card>;
  return <Flex.Column gap="s500">
      <RoomSkeletonDesktop />
      <RoomSkeletonDesktop />
      <RoomSkeletonDesktop />
    </Flex.Column>;
};

require("./RoomSectionSkeleton.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RoomSectionSkeleton.tsx");